export default "__VITE_ASSET__Dx5TOEXD__ 400w, __VITE_ASSET__BqZLr2Za__ 800w, __VITE_ASSET__OyO5p4_z__ 1024w";